import React, { Component } from "react";
import {
  AutoSizer,
  List,
  CellMeasurer,
  CellMeasurerCache
} from "react-virtualized";

export class TabSelectMenuListPane extends Component {
  static defaultProps = {
    maxListHeight: 390
  };

  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: false,
      // HACK: window.innerHeight + 1 is a hack force is to do initial calculation as if there is a scroll bar
      // https://github.com/bvaughn/react-virtualized/issues/401#issuecomment-523090714
      defaultHeight: window.innerHeight + 1
    });
    this.renderRow = this.renderRow.bind(this);
    this.state = {
      listHeight: props.maxListHeight,
      prevTotalRowsHeight: null
    };
  }

  componentDidUpdate(prevProps) {
    if (this.listRef && prevProps.searchValue !== this.props.searchValue) {
      this.cache.clearAll();
      this.listRef.forceUpdateGrid();
    }

    // resizes the container depending on the items that are within the list
    const totalRowsHeight = this.listRef.Grid.getTotalRowsHeight();
    if (totalRowsHeight !== this.state.prevTotalRowsHeight) {
      this.setState({
        prevTotalRowsHeight: totalRowsHeight,
        listHeight: Math.min(this.props.maxListHeight, totalRowsHeight)
      });
    }
  }

  renderRow({ index, parent, key, style }) {
    return (
      <CellMeasurer
        cache={this.cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {this.props.menuItems[index].render({
          active: index === this.props.activeRowIndex,
          onClick: this.props.menuItems[index].onSelect,
          style,
          key
        })}
      </CellMeasurer>
    );
  }

  render() {
    return (
      <AutoSizer disableHeight>
        {({ width }) => (
          <List
            ref={list => (this.listRef = list)}
            width={width}
            height={this.state.listHeight}
            columnCount={0}
            rowCount={this.props.menuItems.length}
            rowHeight={this.cache.rowHeight}
            rowRenderer={this.renderRow}
            activeRowIndex={this.props.activeRowIndex}
            deferredMeasurementCache={this.cache}
            overscanRowCount={5}
            scrollToAlignment="start"
            scrollToIndex={this.props.activeRowIndex}
          />
        )}
      </AutoSizer>
    );
  }
}
